import { useEffect, useRef } from "react";

import subscribeToViewerReceipts from "./viewerReceipts";

// Subscribe a component to the viewer's shared receipts channel. `onEvent` receives
// { type: "receipt", receipt } and { type: "resync" }; it's held in a ref so re-renders don't
// resubscribe. See viewerReceipts.js for the shared-channel semantics.
export default function useViewerReceipts(onEvent) {
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => subscribeToViewerReceipts((event) => onEventRef.current?.(event)), []);
}
